const styles = (theme) => ({
  dialogActions: {
    display: 'flex',
    flexDirection: 'column',
  },
  submitButton: {
    marginBottom: '19px',
    width: '190px',
  },
  infoBlock: {
    fontSize: '16px',
    lineHeight: '19px',
  },
  modalTitle: {
    paddingTop: '20px',
  },
  error: {
    paddingTop: '15px',
  },
})

export default styles
